import PratusSelect from 'components/DesignSystems/New/PratusSelect';
import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
import { calculateGridTemplateColumns as calculateGridTemplateColumnsDefault } from './calculateGridTemplateColumns';

type SelectedOption = {
  value: string;
  label: string;
};

type ColumnDefinition = {
  key: string;
  label: string;
  filterOptions: string[];
};

type FilterCardHeaderProps = {
  filters: {
    [key: string]: string;
  };
  onFilterChange: (filterType: string, value: string) => void;
  clearFilters: () => void;
  columns: ColumnDefinition[];
  calculateGridTemplateColumns?: (numColumns: number) => string;
};

const FilterCardHeader = ({
  filters,
  onFilterChange,
  clearFilters,
  columns,
  calculateGridTemplateColumns = calculateGridTemplateColumnsDefault, // allow injection of custom grid template calculation function
}: FilterCardHeaderProps) => {
  const handleFilterChange = (
    key: string,
    selectedOption: SelectedOption | null
  ) => {
    if (selectedOption) {
      const { label } = selectedOption as SelectedOption;
      onFilterChange(key, label);
    }
  };

  const gridTemplateColumns = calculateGridTemplateColumns(columns.length);

  return (
    <div
      className="filter-header filter-card-header"
      style={{
        gridTemplateColumns: gridTemplateColumns,
      }}
    >
      <div></div>
      {columns.map(({ key, label, filterOptions }) => (
        <div key={key}>
          {label}
          <div className="me-2">
            <PratusSelect
              value={
                filters[key]
                  ? { value: filters[key], label: filters[key] }
                  : undefined
              }
              options={(filterOptions ?? []).map((name) => ({
                value: name,
                label: name,
              }))}
              onChange={(selectedOption) =>
                handleFilterChange(key, selectedOption as SelectedOption | null)
              }
            />
          </div>
        </div>
      ))}
      <div className="clear-filters">
        <StylishNewButton
          className="button--primary"
          onClick={() => {
            clearFilters();
          }}
        >
          Clear Filters
        </StylishNewButton>
      </div>
    </div>
  );
};

export default FilterCardHeader;
